import { Box } from '@mui/material'
import { ImageField, RecordRepresentation, ReferenceField, useRecordContext } from 'react-admin'

import { AdvancedInfoWindow, HeaderSection, InfoWindowDivider } from './AdvancedInfoWindow'
import StationaryEventSection from './StationaryEventSection'
import TelematicContextSection from './TelemacticContextSection'
import VehicleStateSection from './VehicleStateSection'
import VehicleUsageSection from './VehicleUsageSection'

const VehicleTelematicInfoWindow = () => (
  <ReferenceField reference="vehicles" source="vehicle_id" link={false}>
    <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: 1, color: '#111', fontWeight: 700 }}>
      <ImageField source="picture" sx={{ '& img': { maxWidth: 50, maxHeight: 30 } }} />
      <RecordRepresentation />
    </Box>
  </ReferenceField>
)

const VehicleTelematicsInfoWindowContent = () => {
  const record = useRecordContext()

  return (
    <>
      {!(record.extra_data?.timeline?.length > 0) ? (
        <>
          <TelematicContextSection />
          <InfoWindowDivider />
          <HeaderSection title={'usage'} />
          <VehicleUsageSection />
        </>
      ) : (
        <StationaryEventSection />
      )}

      <InfoWindowDivider />

      <HeaderSection title={'vehicleState'} />
      <VehicleStateSection />
    </>
  )
}

const VehicleTelematicsInfoWindow = (props) => (
  <AdvancedInfoWindow header={VehicleTelematicInfoWindow} resource="vehicle-telematics" {...props}>
    <VehicleTelematicsInfoWindowContent />
  </AdvancedInfoWindow>
)

export default VehicleTelematicsInfoWindow
